import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import {
  PresenceReportGroupEntity,
  PresenceReportRequestEntity
} from '~/repositories/presence-report/store/presence-report.models';

@Injectable({
  providedIn: 'root'
})
export class PresenceReportService {
  constructor(private readonly http: HttpClient) {}

  public fetchAllOrgans(): Observable<PresenceReportGroupEntity[]> {
    return this.http.get<PresenceReportGroupEntity[]>(`${environment.BACKEND_URL}/presence/allOrgans`);
  }

  public publishPresenceReportDetails(details: PresenceReportRequestEntity) {
    return this.http.post<PresenceReportRequestEntity>(`${environment.BACKEND_URL}/presence/report/export`, details);
  }
}
